import * as React from "react";
const SvgFiRrCarWash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m22.077 13.12-2.057-3.6A5.01 5.01 0 0 0 15.679 7H8.321A5.01 5.01 0 0 0 3.98 9.52l-2.057 3.6A7 7 0 0 0 1 16.594V18a4 4 0 0 0 2 3.463V22a2 2 0 0 0 4 0h10a2 2 0 0 0 4 0v-.537A4 4 0 0 0 23 18v-1.406a7 7 0 0 0-.923-3.474m-16.36-2.608A3 3 0 0 1 8.321 9h7.358a3 3 0 0 1 2.6 1.512L20.277 14H3.723zM21 18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.406q0-.298.036-.594H5v1a1 1 0 0 0 2 0v-1h10v1a1 1 0 0 0 2 0v-1h1.964q.036.295.036.594zM10.586 4.414a2 2 0 0 1 0-2.828l.8-.9a.817.817 0 0 1 1.222 0l.8.9A2.013 2.013 0 0 1 12 5a2 2 0 0 1-1.414-.586m5.985 0a2 2 0 0 1 0-2.828l.8-.9a.817.817 0 0 1 1.223 0l.8.9A2.013 2.013 0 0 1 17.985 5a2 2 0 0 1-1.414-.586m-12 0a2 2 0 0 1 0-2.828l.8-.9a.818.818 0 0 1 1.229 0l.8.9A2.013 2.013 0 0 1 5.985 5a2 2 0 0 1-1.414-.586"
    />
  </svg>
);
export default SvgFiRrCarWash;
